<style lang="scss" scoped>
.nav-tab-wrap {
  z-index: 20;
  width: 100%;
  height: 80px;
  transition: display 0.5s;
  .nav-tab {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 38px;
    font-weight: 300;
    li {
      box-sizing: border-box;
      height: 80px;
      color: #111111;
      font-size: 28px;
      line-height: 80px;
      text-align: center;
      &.active {
        position: relative;
        font-weight: 500;
        font-size: 32px;
        &::before {
          position: absolute;
          bottom: 0;
          left: 50%;
          display: block;
          width: 30px;
          height: 6px;
          background: #ff5555;
          border-radius: 6px;
          transform: translateX(-50%);
          content: '';
        }
        // border-bottom: 6px solid #ff5555;
      }
      &:not(:last-child) {
        margin-right: 48px;
      }
    }
  }
}
</style>

<template>
  <div class="nav-tab-wrap" :style="{ display: navTabOpacity ? '' : 'none' }">
    <ul
      v-if="navTabList && navTabList.length > 2"
      v-zpm="{ sectionid: 129, sortname: 'tab模块' }"
      class="nav-tab"
    >
      <li
        v-for="(item, index) in navTabList"
        :key="item.id"
        v-zpm="{ sortname: item.name, sortid: index }"
        :zz-sortid="index"
        :class="{ active: item.id === curNavTabIndex }"
        @click="scrollToTab(item.id, index)"
      >
        {{ item.name }}
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import {
  computed,
  defineComponent,
  ref,
  onBeforeUnmount,
  watch,
  onMounted,
  Ref
} from '@vue/composition-api'
import SmoothScroll from '@utils/smoothScroll'
import { isPlatform } from '@utils/native'
import { state } from '@/store/index'
import { getQueryString } from '@utils/index'
;(window as any).SmoothScroll = SmoothScroll
let smoothSroll: any = null
interface tabType {
  name: string
  id: string
}

export default defineComponent({
  props: {
    dataInfo: {
      type: Object,
      default: () => {}
    },
    statusHeight: {
      type: Number,
      default: 0
    }
  },
  setup(props, ctx) {
    const { $tiktok } = ctx.root
    $tiktok('created', 'navTab')
    const animating: Ref<boolean> = ref(false)
    const curNavTabIndex: Ref<string> = ref('prod')
    const navTabOpacity: Ref<number> = ref(0)
    const offset: Ref<number> = ref(0)
    const pageHide: Ref<boolean> = ref(false)
    const pageShow: Ref<boolean> = ref(true)

    const monitorPageScroll = () => {
      if (window.scrollY > 100) {
        navTabOpacity.value = 1
      } else {
        navTabOpacity.value = 0
      }
      if (!animating.value) {
        navTabList.value.forEach((tab: tabType, index: number, list: tabType[]) => {
          const getOffsetTop = (id) => {
            const elem: HTMLElement = document.querySelector(`#tab-${id}`) as HTMLElement
            return elem && elem.offsetTop
          }
          const curTop = getOffsetTop(tab.id)
          const nextTop = index < list.length - 1 ? getOffsetTop(list[index + 1].id) : Infinity
          const distance = Math.round(window.scrollY + offset.value)
          if (distance >= curTop && distance <= nextTop) {
            curNavTabIndex.value = tab.id
          }
        })
      }
    }
    const watchHeaderChange: Function = (statusHeight) => {
      let dom_height: number = 0
      if (isPlatform('zz')) {
        const _H = document.querySelector('.header-content') as HTMLElement
        offset.value = Math.ceil(
          Number(_H.clientHeight) + Number(_H.offsetTop) + Number(statusHeight)
        )
      } else {
        dom_height = (80 / 750) * window.innerWidth
        offset.value = Math.ceil(Number(dom_height) + Number(statusHeight))
      }
      smoothSroll = new (window as any).SmoothScroll('.nav-tab li', {
        offset: offset.value,
        updateURL: false
      })

      document.addEventListener('scrollStart', () => {
        animating.value = true
      })
      document.addEventListener('scrollStop', () => {
        animating.value = false
      })
      document.addEventListener('scroll', monitorPageScroll, false)
    }

    const navTabList = computed(() => {
      const preTab: tabType[] = []
      let data: tabType[] = []
      if (state.upgradeStyle == 1) {
        props.dataInfo?.report && preTab.push({ name: '报告', id: 'qcreport' })
        if (!!props.dataInfo.introPics?.length || !!props.dataInfo.productDescribeInfo?.length) {
          preTab.push({ name: '详情', id: 'detail' })
        }
        state.showEvaluate &&
          state.evalListData &&
          state.evalListData.dataList &&
          preTab.push({ name: '评价', id: 'evaluate' })
      } else {
        props.dataInfo?.report && preTab.push({ name: '验机报告', id: 'qcreport' })
        state.showEvaluate && preTab.push({ name: '评价', id: 'evaluate' })
        if (!!props.dataInfo.introPics?.length || !!props.dataInfo.productDescribeInfo?.length) {
          preTab.push({ name: '详情', id: 'detail' })
        }
      }

      if (!state.saleCombineIds && !state.packageId) preTab.push({ name: '推荐', id: 'recommend' })
      data = [
        {
          name: '商品',
          id: 'prod'
        },
        ...preTab
      ]
      return data
    })

    const scrollToTab = (id: string) => {
      const elem: HTMLElement = document.querySelector(`#tab-${id}`) as HTMLElement
      elem && smoothSroll.animateScroll(elem)
      curNavTabIndex.value = id
    }

    watch(
      () => props.statusHeight,
      () => {
        const statusHeight = props.statusHeight
        watchHeaderChange(statusHeight)
      },
      {
        deep: true,
        immediate: true
      }
    )

    /**
     * @description: 微商详锚点到验机报告区域
     * @param {*}
     * @return {*}
     */
    watch(
      () => props.dataInfo,
      () => {
        const anchor: string = getQueryString('anchor') || ''
        if (anchor === 'report') {
          const { pics, report } = props.dataInfo
          if (pics && report) {
            if (!pageShow.value) return
            document.addEventListener('visibilitychange', () => {
              if (document.hidden) {
                //页面隐藏
                pageShow.value = false
              }
            })
            if (pageShow.value) {
              const loadTime = 500 // 给页面500毫秒的加载时间,体验更加丝滑
              setTimeout(() => {
                scrollToTab('qcreport')
              }, loadTime)
            }
          }
        }
      }
    )

    onBeforeUnmount(() => {
      document.removeEventListener('scroll', monitorPageScroll)
      pageHide.value = false
    })

    onMounted(() => {
      $tiktok('mounted', 'navTab')
    })

    return {
      animating,
      curNavTabIndex,
      navTabOpacity,
      navTabList,
      scrollToTab
    }
  }
})
</script>
